import Vue from "vue";
import Router from "vue-router";
import { getToken } from "@/utils/auth";
import { setStatusBar } from "@/utils/index";
import store from "@/store";
import { httpGetInitInfo, httpGetUserInfo } from "@/api/login";
Vue.use(Router);

const needLoginList = [
  "/coinPurse",
  "/dappwallet",
  "/send",
  "/against",
  "/receive",
  "/addressBook",
  "/addAddress",
  "/historyNotice",
  "/setUp",
  "/coinDetail",
  "/payPassword",
  "/share",
  "/mywealth",
  "/ploydetail",
  "/buyploy",
  "/sellploy",
  "/query",
  "/plandetail",
  "/sendEnvelope",
]; // no redirect whitelist

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/index/home",
    },
    {
      path: "/index",
      redirect: "/index/home",
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("./views/Register.vue"),
    },
    {
      path: "/forget",
      name: "Forget",
      component: () => import("./views/Forget.vue"),
    },
    {
      path: "/password",
      name: "Password",
      component: () => import("./views/Password.vue"),
    },
    {
      path: "/index",
      name: "Index",
      component: () => import("./views/Index.vue"),
      children: [
        // 当 /user/:id 匹配成功，
        // UserHome 会被渲染在 User 的 <router-view> 中
        { path: "home", component: () => import("./views/index/Home.vue") },
        {
          path: "market",
          component: () => import("./views/hangqing/Index.vue"),
        },
        {
          path: "wealth",
          component: () => import("./views/wealth/Index1.vue"),
        },
        { path: "game", component: () => import("./views/index/Game.vue") },
        { path: "find", component: () => import("./views/faxian/Index.vue") },
        { path: "mypage", component: () => import("./views/wode/Index1.vue") },
        { path: "nologin", component: () => import("./views/NoLogin.vue") },
        { path: "*", redirect: "/404" },
        // ...其他子路由
      ],
    },
    {
      path: "/coinList",
      name: "CoinList",
      component: () => import("./views/index/CoinList.vue"),
    },
    {
      path: "/hangqing",
      name: "Hangqing",
      component: () => import("./views/hangqing/Index.vue"),
    },
    {
      path: "/edit-info",
      name: "Editinfo",
      component: () => import("./views/index/EditInfo.vue"),
    },
    {
      path: "/coinPurse",
      name: "CoinPurse",
      component: () => import("./views/index/CoinPurse.vue"),
    },
    {
      path: "/send",
      name: "Send",
      component: () => import("./views/index/Send.vue"),
    },
    {
      path: "/send-network",
      name: "SendNetwork",
      component: () => import("./views/index/SendNetwork.vue"),
    },
    {
      path: "/against",
      name: "Against",
      component: () => import("./views/index/Against.vue"),
    },
    {
      path: "/receive",
      name: "Receive",
      component: () => import("./views/index/Receive.vue"),
    },
    {
      path: "/receive-network",
      name: "ReceiveNetwork",
      component: () => import("./views/index/ReceiveNetwork.vue"),
    },
    {
      path: "/addressBook",
      name: "AddressBook",
      component: () => import("./views/index/AddressBook.vue"),
    },
    {
      path: "/addnft",
      name: "Addnft",
      component: () => import("./views/index/AddNft.vue"),
    },
    {
      path: "/outnft",
      name: "Outnft",
      component: () => import("./views/index/OutNft.vue"),
    },
    {
      path: "/nftaddress",
      name: "Nftaddress",
      component: () => import("./views/index/NftAddress.vue"),
    },
    {
      path: "/nfthistory",
      name: "Nfthistory",
      component: () => import("./views/index/NftHistory.vue"),
    },
    {
      path: "/nfthistoryinfo",
      name: "Nfthistoryinfo",
      component: () => import("./views/index/NftHistoryInfo.vue"),
    },
    {
      path: "/addAddress",
      name: "AddAddress",
      component: () => import("./views/index/AddAddress.vue"),
    },
    {
      path: "/historyNotice",
      name: "HistoryNotice",
      component: () => import("./views/index/HistoryNotice.vue"),
    },
    {
      path: "/setUp",
      name: "SetUp",
      component: () => import("./views/index/SetUp.vue"),
    },
    {
      path: "/bindEmail",
      name: "BindEmail",
      component: () => import("./views/index/BindEmail.vue"),
    },
    {
      path: "/bindMobile",
      name: "BindMobile",
      component: () => import("./views/index/BindMobile.vue"),
    },
    {
      path: "/search",
      name: "Search",
      component: () => import("./views/index/Search.vue"),
    },
    {
      path: "/coinDetail",
      name: "CoinDetail",
      component: () => import("./views/index/CoinDetail.vue"),
    },
    {
      path: "/payPassword",
      name: "PayPassword",
      component: () => import("./views/index/PayPassword.vue"),
    },
    {
      path: "/rePayPassword",
      name: "RePayPassword",
      component: () => import("./views/index/RePayPassword.vue"),
    },
    {
      path: "/forgetPayPass",
      name: "ForgetPayPass",
      component: () => import("./views/index/ForgetPayPass.vue"),
    },
    {
      path: "/googleCode",
      name: "GoogleCode",
      component: () => import("./views/index/GoogleCode.vue"),
    },
    {
      path: "/googleCheck",
      name: "GoogleCheck",
      component: () => import("@/views/wode/GoogleCheck.vue"),
    },
    {
      path: "/firstSetPayPassword",
      name: "FirstSetPayPassword",
      component: () => import("./views/index/FirstSetPayPassword.vue"),
    },
    {
      path: "/codeCheck",
      name: "CodeCheck",
      component: () => import("./views/index/CodeCheck.vue"),
    },
    {
      path: "/editPayPassword",
      name: "EditPayPassword",
      component: () => import("./views/index/EditPayPassword.vue"),
    },
    {
      path: "/setPayPassword",
      name: "SetPayPassword",
      component: () => import("./views/index/SetPayPassword.vue"),
    },
    {
      path: "/googleValid",
      name: "GoogleValid",
      component: () => import("./views/index/GoogleValid.vue"),
    },
    {
      path: "/securityLevel",
      name: "SecurityLevel",
      component: () => import("./views/index/SecurityLevel.vue"),
    },
    {
      path: "/levelThree",
      name: "LevelThree",
      component: () => import("./views/index/LevelThree.vue"),
    },
    {
      path: "/levelThreeApply",
      name: "RealNameApply",
      component: () => import("./views/index/RealNameApply.vue"),
    },
    {
      path: "/levelThreeApplyKR",
      name: "RealNameApplyKR",
      component: () => import("./views/index/RealNameApplyKR.vue"),
    },
    {
      path: "/levelThreeApplyJP",
      name: "RealNameApplyJP",
      component: () => import("./views/index/RealNameApplyJP.vue"),
    },
    {
      path: "/backup",
      name: "Backup",
      component: () => import("./views/index/Backup.vue"),
    },
    {
      path: "/mnemonicWord",
      name: "MnemonicWord",
      component: () => import("./views/index/MnemonicWord.vue"),
    },
    {
      path: "/safety",
      name: "Safety",
      component: () => import("./views/index/Safety.vue"),
    },
    {
      path: "/lookWords",
      name: "LookWords",
      component: () => import("./views/index/LookWords.vue"),
    },
    {
      path: "/selectWords",
      name: "SelectWords",
      component: () => import("./views/index/SelectWords.vue"),
    },
    {
      path: "/coinAgaList",
      name: "CoinAgaList",
      component: () => import("./views/index/CoinAgaList.vue"),
    },
    {
      path: "/sendEnvelope",
      name: "SendEnvelope",
      component: () => import("./views/index/SendEnvelope.vue"),
    },
    {
      path: "/redCoinList",
      name: "RedCoinList",
      component: () => import("./views/index/RedCoinList.vue"),
    },
    {
      path: "/redEnvelopeRecord",
      name: "RedEnvelopeRecord",
      component: () => import("./views/index/RedEnvelopeRecord.vue"),
    },
    {
      path: "/hDsearch",
      name: "HDsearch",
      component: () => import("./views/index/HDsearch.vue"),
    },
    {
      path: "/redEnvelopeDetail",
      name: "RedEnvelopeDetail",
      component: () => import("./views/index/RredEnvelopeDetail.vue"),
    },
    {
      path: "/hangqingAdd",
      name: "hangqingAdd",
      component: () => import("./views/hangqing/Add.vue"),
    },
    {
      path: "/hangqingSort",
      name: "hangqingSort",
      component: () => import("./views/hangqing/Sortable.vue"),
    },
    {
      path: "/faxian",
      name: "Faxian",
      component: () => import("./views/faxian/Index.vue"),
    },
    {
      path: "/faxiantype",
      name: "FaxianType",
      component: () => import("./views/faxian/TypeList.vue"),
    },
    {
      path: "/dappwallet",
      name: "Dappwallet",
      component: () => import("./views/faxian/Dappwallet.vue"),
    },
    {
      path: "/share",
      name: "Share",
      component: () => import("./views/wode/Share.vue"),
    },
    {
      path: "/shequn",
      name: "Shequn",
      component: () => import("./views/wode/Shequn.vue"),
    },
    {
      path: "/invitationDetail",
      name: "InvitationDetail",
      component: () => import("./views/wode/InvitationDetail.vue"),
    },
    {
      path: "/mycc",
      name: "Mycc",
      component: () => import("./views/wode/Mycc.vue"),
    },
    {
      path: "/task",
      name: "Task",
      component: () => import("./views/wode/Task.vue"),
    },
    {
      path: "/shop",
      name: "Shop",
      component: () => import("./views/wode/Shop.vue"),
    },
    {
      path: "/shopinfo",
      name: "Shopinfo",
      component: () => import("./views/wode/Shopinfo.vue"),
    },
    {
      path: "/myccorder",
      name: "Myccorder",
      component: () => import("./views/wode/Myccorder.vue"),
    },
    {
      path: "/shoporder",
      name: "Shoporder",
      component: () => import("./views/wode/Shoporder.vue"),
    },
    {
      path: "/taskorder",
      name: "Taskorder",
      component: () => import("./views/wode/Taskorder.vue"),
    },
    {
      path: "/pinset",
      name: "PinSet",
      component: () => import("./views/wode/PinSet.vue"),
    },
    {
      path: "/pincheck",
      name: "PinCheck",
      component: () => import("./views/wode/PinCheck.vue"),
    },
    {
      path: "/huobi",
      name: "Huobi",
      component: () => import("./views/wode/Huobi.vue"),
    },
    {
      path: "/redgreen",
      name: "RedGreen",
      component: () => import("./views/wode/RedGreen.vue"),
    },
    {
      path: "/zixun",
      name: "Zixun",
      component: () => import("./views/wode/Zixun.vue"),
    },
    {
      path: "/pos",
      name: "Pos",
      component: () => import("./views/wealth/Pos.vue"),
    },
    {
      path: "/coinplan",
      name: "Coinplan",
      component: () => import("./views/wealth/Coinplan.vue"),
    },
    {
      path: "/mywealth",
      name: "Mywealth",
      component: () => import("./views/wealth/Mywealth.vue"),
    },
    {
      path: "/plandetail",
      name: "Plandetail",
      component: () => import("./views/wealth/Plandetail.vue"),
    },
    {
      path: "/buyploy",
      name: "Buyploy",
      component: () => import("./views/wealth/Buyploy.vue"),
    },
    {
      path: "/sellploy",
      name: "Sellploy",
      component: () => import("./views/wealth/Sellploy.vue"),
    },
    {
      path: "/ploydetail",
      name: "Ploydetail",
      component: () => import("./views/wealth/Ploydetail.vue"),
    },
    {
      path: "/query",
      name: "Query",
      component: () => import("./views/wealth/Query.vue"),
    },
    {
      path: "/info",
      name: "Info",
      component: () => import("./views/wealth/Info.vue"),
    },
    {
      path: "/setlanguage",
      name: "Setlanguage",
      component: () => import("./views/wode/Setlanguage.vue"),
    },
    {
      path: "/game_detail",
      name: "GameDetail",
      component: () => import("./views/index/GameDetail.vue"),
    },
    {
      path: "/add_trend",
      name: "AddTrend",
      component: () => import("./views/trend/AddTrend.vue"),
    },
    {
      path: "/trend_detail",
      name: "TrendDetail",
      component: () => import("./views/trend/TrendDetail.vue"),
    },
    {
      path: "/trend_mine",
      name: "TrendMine",
      component: () => import("./views/trend/TrendMine.vue"),
    },
    {
      path: "/token/create",
      name: "TokenCreate",
      component: () => import("./views/token/create.vue"),
    },
    {
      path: "/to_personal",
      name: "PersonalData",
      component: () => import("./views/index/PersonalData.vue"),
    },
    {
      path: "/token/order",
      name: "TokenOrder",
      component: () => import("./views/token/order.vue"),
    },
    {
      path: "/404",
      component: () => import("@/views/errorPage/404"),
    },
    {
      path: "/bind_role",
      name: "BindRole",
      component: () => import("./views/index/BindRole.vue"),
      meta: { keepAlive: false },
    },
    {
      path: "/trend_complaint",
      name: "ComplaintTrend",
      component: () => import("./views/trend/ComplaintTrend.vue"),
    },
    {
      path: "/user-agreement",
      name: "userAgreement",
      component: () => import("./views/staticArticle/userAgreement/index.vue"),
    },
    {
      path: "/change-password",
      name: "ChangePassword",
      component: () => import("./views/ChangePassword.vue"),
    },
    {
      path: "/realState",
      name: "RealState",
      component: () => import("./views/wode/RealState.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (Object.keys(store.state.initInfo).length != 0) {
    myNext(to, from, next);
  } else {
    getInitInfo(to, from, next);
  }
});

function getInitInfo(to, from, next) {
  //网络请求太慢白屏，不等网络请求直接进页面
  myNext(to, from, next);
  httpGetInitInfo()
    .then((res) => {
      store.dispatch("setInitInfo", res.data);
      //myNext(to, from, next)
    })
    .catch((e) => {
      //myNext(to, from, next)
      //console.log(e)
      //getInitInfo(to, from, next)
    });
}

function getUserInfo(to, from, next) {
  httpGetUserInfo()
    .then((res) => {
      store.dispatch("setUserInfo", res.data);
      next(to, from, next);
    })
    .catch((code) => {
      if (code == 10001) {
        store.dispatch("removeToken");
        next({
          path: "/login",
        });
      }
    });
}
//const needChangeBar = ['/index/home','/index/nologin','/CoinPurse','/index/wealth','/share']
function myNext(to, from, next) {
  // if(needChangeBar.indexOf(to.path) != -1){
  //   setStatusBar('#046afd')
  // }else{
  //   setStatusBar('#ffffff')
  // }
  if (getToken()) {
    if (Object.keys(store.state.userInfo).length == 0) {
      getUserInfo(to, from, next);
    }
    next();
  } else {
    if (needLoginList.indexOf(to.path) !== -1) {
      next(`/login?redirect=${to.path}`);
    } else {
      next();
    }
  }
}

export default router;
